<div
  class="flex justify-content-end align-items-center top-0 -mt-1 absolute right-0 z-1 gap-3">
  @if (activeUserStore.canAccessEntityAdder()) {
    <p-button
      size="small"
      [text]="true"
      [raised]="true"
      [rounded]="true"
      pTooltip="Standort oder Raum hinzufügen"
      icon="fas fa-plus-circle"
      (onClick)="addLayerType()"></p-button>
  }

  <app-search-input
    inputStyleClass="max-w-13rem"
    (search)="filterTypes($event)"></app-search-input>
</div>

<p-tabView appAddClassToTabPanels [(activeIndex)]="activeTabIndex">
  <p-tabPanel *ngFor="let type of ['Polygon', 'Point']">
    <ng-template pTemplate="header">
      <div class="flex align-items-center gap-2">
        <i
          [ngClass]="{
            'fa-regular fa-map': type === 'Polygon',
            'fas fa-location-dot': type === 'Point',
          }"></i>
        <span>{{
          type === 'Polygon' ? 'Räume' : type === 'Point' ? 'Standorte' : 'POIs'
        }}</span>
      </div>
    </ng-template>
    @if (
      groupedDataLayerTypes &&
      groupedDataLayerTypes[type] &&
      dataLayerStore.initialized()
    ) {
      <p-scrollPanel styleClass="h-14rem">
        <div cdkDropList (cdkDropListDropped)="drop($event)">
          @for (
            dataLayerType of groupedDataLayerTypes[type];
            track dataLayerType._id
          ) {
            <div
              cdkDrag
              [cdkDragData]="dataLayerType"
              class="surface-border"
              [ngClass]="{
                'border-bottom-1': !$last,
                'border-bottom-none': $last,
              }">
              <app-data-layer-type-entry
                [ngClass]="{
                  'border-right-3 border-primary text-primary':
                    selectedType?._id === dataLayerType._id,
                }"
                class="pt-1 pb-3 block"
                (addYear)="addYear($event)"
                [dataLayerType]="dataLayerType"></app-data-layer-type-entry>
            </div>
          }
        </div>
      </p-scrollPanel>
    } @else if (
      type !== 'Point' &&
      !permissionStore.canAccessWorkspaceType(
        type === 'Polygon' ? 'dataLayerType' : 'poiDataLayerType'
      )
    ) {
      <app-alert
        styleclass="m-0 p-2"
        header="Zugriff verweigert"
        [canToggle]="false">
        <p>
          Sie haben keine Berechtigung, diese Ebene anzuzeigen. Bitte wenden Sie
          sich an Ihren Administrator, um Zugriff auf Räume zu erhalten.
        </p>
      </app-alert>
    } @else {
      <app-alert
        styleclass="m-0 p-2"
        [header]="
          type === 'Polygon'
            ? 'Keine Räume gefunden'
            : type === 'Point'
              ? 'Keine Standorte gefunden'
              : 'Keine POIs gefunden'
        "
        [canToggle]="false">
        <p>
          Legen Sie
          {{
            type === 'Polygon'
              ? 'Räume'
              : type === 'Point'
                ? 'Standorte'
                : 'POIs'
          }}
          in der in Ihrem Atlas an.
        </p>

        <p>
          <p-button
            [routerLink]="[
              '/data-backend',
              {
                outlets: {
                  overlay: [
                    'neu',
                    {
                      outlets: {
                        panel: [
                          type === 'Polygon'
                            ? 'raum'
                            : type === 'Point'
                              ? 'poi'
                              : 'poi',
                          'neu',
                        ],
                      },
                    },
                  ],
                },
              },
            ]"
            icon="fas fa-circle-plus"
            label="jetzt anlegen"
            [rounded]="true"></p-button>
        </p>
      </app-alert>
    }
  </p-tabPanel>
</p-tabView>

<p-sidebar
  (onHide)="onOverlayClose()"
  position="right"
  [modal]="false"
  [styleClass]="'w-11'"
  [visible]="editFormOverlay">
  <ng-template pTemplate="header">
    <app-header
      [icon]="editFormOverlayIcon"
      [text]="store.selectedItem().name || 'Ebene bearbeiten'"></app-header
  ></ng-template>
  <ng-container *ngIf="editFormOverlay">
    <router-outlet name="bearbeiten"></router-outlet>
  </ng-container>
</p-sidebar>
<app-mask [visible]="editFormOverlay" (click)="onOverlayClose()"></app-mask>

@if (addDataLayerForm) {
  <p-sidebar
    (onHide)="closeDataLayerForm()"
    position="right"
    [modal]="false"
    [styleClass]="'w-7'"
    [visible]="addDataLayerForm">
    <ng-template pTemplate="header">
      <app-header
        icon="fas fa-calendar-days"
        text="Jahr hinzufügen"></app-header
    ></ng-template>
    <ng-container *ngIf="addDataLayerForm">
      <app-data-layer-form
        [cancelLevel]="0"
        (formSubmitted)="closeDataLayerForm()"
        (cancel)="closeDataLayerForm()"
        [parent]="addToParent"></app-data-layer-form>
    </ng-container>
  </p-sidebar>
  <app-mask
    [visible]="addDataLayerForm"
    (click)="closeDataLayerForm()"></app-mask>
}
